import * as React from "react";
import { useGetCertificationsQuery } from "../services/certification.service";
import SelectBase, { SelectOption } from "./global/SelectBase";

const SelectCertification = ({
  onChange,
  value,
  error,
  helperText,
}: {
  onChange: (arg?: number) => void;
  value: number;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const {
    data: certs,
    isLoading,
  } = useGetCertificationsQuery({
    page: 0,
    pageSize: 1000,
  });

  const options = React.useMemo<SelectOption[]>(() => {
    return (certs?.data || []).map((cert) => ({
      label: cert.name,
      value: cert.id,
    }));
  }, [certs]);

  const selected = React.useMemo<SelectOption | null>(() => {
    if (!value || !certs?.data) return null;
    const cert = certs.data.find((it) => it.id == value);
    return cert ? { label: cert.name, value: cert.id } : null;
  }, [certs, value]);

  return (
    <SelectBase
      options={options}
      value={selected}
      onChange={(newValue) => {
        const option = newValue as SelectOption | null;
        onChange(option?.value as number | undefined);
      }}
      label="Select Certification"
      placeholder="Search..."
      isLoading={isLoading}
      error={error}
      helperText={helperText}
    />
  );
};
export default SelectCertification;
